import { render, staticRenderFns } from "./LocalFilePicker.vue?vue&type=template&id=4797ae31&scoped=true"
import script from "./LocalFilePicker.vue?vue&type=script&lang=js"
export * from "./LocalFilePicker.vue?vue&type=script&lang=js"
import style0 from "./LocalFilePicker.vue?vue&type=style&index=0&id=4797ae31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797ae31",
  null
  
)

export default component.exports